"use client";

import { useCallback, useState } from "react";
import { getErrorMessage } from "@/lib/utils";

export function useFormSubmit(fn: () => Promise<void>) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = useCallback(async () => {
    setError("");
    setLoading(true);
    try {
      await fn();
    } catch (err: unknown) {
      setError(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }, [fn]);

  const clearError = useCallback(() => setError(""), []);

  return { submit, error, setError, loading, clearError } as const;
}
